module.exports = __webpack_public_path__ + "img/sample-id-card.ce7d8de3.png";